// src/app/features/markets/marketContext.jsx
import React, { createContext, useContext, useMemo, useState } from "react";
import { ASSET_CLASSES, MARKET_CATALOG, getMarketById } from "./marketCatalog";

const MarketCtx = createContext(null);

export function MarketProvider({ children }) {
  const [assetClass, setAssetClass] = useState(ASSET_CLASSES.CRYPTO);

  // Use ID for state management (BTCUSDT, EURUSD, XAUUSD)
  const firstMarket = MARKET_CATALOG?.[ASSET_CLASSES.CRYPTO]?.[0];
  const [marketId, setMarketId] = useState(firstMarket?.id || "BTCUSDT");

  // When switching asset class, default to first market of that class
  const setAsset = (nextClass) => {
    setAssetClass(nextClass);
    const first = MARKET_CATALOG?.[nextClass]?.[0];
    if (first) setMarketId(first.id);
  };

  // Get current market details
  const currentMarket = useMemo(() => {
    return getMarketById(marketId) || MARKET_CATALOG?.[assetClass]?.[0] || null;
  }, [marketId, assetClass]);

  const value = useMemo(
    () => ({
      assetClass,
      marketId,
      setMarketId,
      setAssetClass: setAsset,
      markets: MARKET_CATALOG?.[assetClass] || [],
      currentMarket,
      // Convenience getters
      symbol: currentMarket?.symbol || "",          // Backend symbol (BTC, EURUSD)
      displayLabel: currentMarket?.label || "",     // Display (BTC/USDT, EUR/USD)
      decimals: currentMarket?.decimals || 2,
    }),
    [assetClass, marketId, currentMarket]
  );

  return <MarketCtx.Provider value={value}>{children}</MarketCtx.Provider>;
}

export function useMarket() {
  const ctx = useContext(MarketCtx);
  if (!ctx) throw new Error("useMarket must be used inside <MarketProvider />");
  return ctx;
}
